export default __webpack_public_path__ + "static/media/pdf-cancelled.b09f96fa.svg";